import React from "react";

export const MoveIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        stroke="#113357"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M3 10h.5m3 0H8m3 0h6M14 14l4-4M14 6l4 4"
      ></path>
    </svg>
  );
};
